/**
 * Retrieves the family members of the currently authenticated user.
 * No input parameters are required because it is assumed the user is logged on.
 * If the user is not logged on or is not a secure user, then we don't know the NRN and can not
 * resolve the family composition. In this case the service resolves null.
 * @returns {Promise<null|[{firstName: string, dependsOn: null, name: string, nrn: string}, {firstName: string, dependsOn: string, name: string, nrn: string}]|*>}
 * @throws In case the fetch command fails.
 */
export async function findFamilyMembers () {
  const response = await fetch('/ezvk-app/api/members/nrn');

  // if the user is not signed in or is not a secure user
  if (response.status === 401 || response.status === 403) {
    return null;
  }

  if (response.status === 200) {
    const body = await response.json();
    return body.member; // this is an array, poor property name.
  }

  throw new Error(`Strange response status returned: ${response.status}`);
}

export function findMemberNameForNrn (familyMembers, nrn) {
  const member = (familyMembers ?? []).find((familyMember) => familyMember.nrn === nrn);
  if (!member) return nrn;
  return `${member.firstName} ${member.name}`;
}
